import { el } from 'redom';
import * as ReactDOM from 'react-dom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import { getPropertyValues } from 'utilities/collection';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import SaveButton from 'generics/components/save-button';
import TextareaInput from 'generics/components/text-input/textarea';
import { render as contactsInputRenderer } from 'root/startup-view/customers/customer-message-editor/contacts-input';

import './index.scss';

class AddSigneesPanel {

  constructor(configuration) {

    this.panelId = configuration.panelId;
    this.signeeIds = [];
    this.note = '';
    this.placeholder = configuration.placeholder;
    this.onComplete = configuration.onComplete;
    this.onCancel = configuration.onCancel;
    this.outsideEventRegistration = null;

    this.signeeInputRow = el('.signee-input-row.hide-scrollbar');
    this.noteInput = new TextareaInput({
      placeholder: 'Add a note',
      onChange: this.handleNoteChange.bind(this)
    });

    this.el = el('.add-signees-panel', [
      el('.add-signees-panel-inputs', [
        this.renderContactsInput(),
        this.noteInput
      ]),
      el('.add-signees-panel-actions', [
        new SaveButton({
          label: 'Save',
          onClick: this.save.bind(this)
        })
      ])
    ]);

  }

  renderContactsInput() {

    const panel = this;

    const component = contactsInputRenderer({
      contacts: [],
      placeholder: this.placeholder,
      limit: 20,
      allowManualContact: true,
      onChange(contacts) {
        panel.signeeIds = getPropertyValues(contacts, 'startupUserId');
      },
      addContact: this.tryCreateContact.bind(this)
    });

    ReactDOM.unmountComponentAtNode(this.signeeInputRow);
    ReactDOM.render(component, this.signeeInputRow);

    return this.signeeInputRow;

  }

  async save() {

    let signees = await serverInterface.startup.signaturePanel.addSignees(this.panelId, {
      signeeIds: this.signeeIds,
      note: this.note
    });

    this.onComplete(signees);

  }

  handleNoteChange(event, value) {

    this.note = value;

  }

  async tryCreateContact(emailAddress) {

    try {

      const startupUser = await serverInterface.startup.users.customers.createCustomerForEmailAddress({ emailAddress });

      const startupUserId = startupUser._id;

      const contact = {
        _id: startupUserId,
        name: startupUser.fullName || startupUser.email,
        value: startupUser.email,
        profilePicture: startupUser.profilePicture,
        startupUserId
      };

      return contact;

    } catch (exception) {

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Please enter valid email address',
        seconds: 5,
        type: 'error'
      });

      return null;

    }

  }

  handleOutsideClickEvent() {

    this.onCancel();

  }

  onmount() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.handleOutsideClickEvent.bind(this));

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default AddSigneesPanel;